import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useTranslation } from 'react-i18next';

import { TOKENS, Plate } from '../worktimeLib';

/**
 * P-switch (§8): confirm switching from one work order to another. Only shown when parallel
 * clocking is OFF (the backend would otherwise end the current WO session and start the new one).
 */
export default function PSwitchDialog({ open, fromReg, toReg, onConfirm, onCancel, busy }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '10px',
            backgroundColor: TOKENS.tint,
            color: TOKENS.accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SwapHorizIcon fontSize="small" />
        </Box>
        {t('worktime.switch.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t('worktime.switch.body')}
        </DialogContentText>
        <Box sx={{ backgroundColor: TOKENS.bg, borderRadius: 2, p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ fontSize: 13, color: TOKENS.muted }}>{t('worktime.switch.stopping')}</Box>
            <Plate>{fromReg || '—'}</Plate>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ fontSize: 13, color: TOKENS.muted }}>{t('worktime.switch.starting')}</Box>
            <Plate>{toReg || '—'}</Plate>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" disabled={busy}>
          {t('common.cancel', 'Peruuta')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={busy}
          sx={{ backgroundColor: TOKENS.green, '&:hover': { backgroundColor: TOKENS.greenDark } }}
        >
          {t('worktime.switch.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
